


























import Vue from 'vue'
import { gaEventTracker, EVENT_CATEGORIES } from '@/common/utils'
import { ENDPOINTS } from '@/product/const'
import { SYSTEM_ERROR } from '@/common/const'
import { mapMutations } from 'vuex'
import axios from 'axios'
export default Vue.extend({
  props: {
    analyticsValue: {
      type: String,
      required: false,
      default: ''
    },
    eventAction: {
      type: String,
      required: false,
      default: ''
    },
    eventLabel: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    editorUrl(): string {
      return `/editor?psi=${this.$store.getters.estimate.printable_sku_id}&quantity=${this.$store.getters.estimateQuantity}&trial=${this.$store.getters.estimate.trial}`
    },
    disableLink(): boolean {
      return !this.$store.getters.isSendable || this.$store.state.productLoading
    },
    eventCategory() {
      return EVENT_CATEGORIES.PRODUCT_DETAIL
    },
    printingCapacity(): number | undefined {
      return this.$store.getters.estimate.print_capacity_per_day?.remaining_quantity
    },
    currentQuantity(): number {
      return this.$store.getters.estimate.quantity
    }
  },
  methods: {
    ...mapMutations([
      'setPrintingCapacity'
    ]),
    eventTracker() {
      const payload = {
        category: this.eventCategory,
        action: this.eventAction,
        label: this.eventLabel
      }
      gaEventTracker(payload)
    },
    async validatePrintingCapacity(event: Event) {
      if (this.printingCapacity) {
        try {
          event.preventDefault()
          const { quantity, trial } = this.$route.query
          const url = ENDPOINTS.ESTIMATE.replace(/%id/, this.$store.getters.estimate.printable_sku_id)
          const request = await axios.get(url, { params: { quantity, trial }})
          const currentPrintingCapacity = request.data.print_capacity_per_day?.remaining_quantity
          if (this.currentQuantity > currentPrintingCapacity) {
            this.setPrintingCapacity(request.data.print_capacity_per_day.remaining_quantity)
            this.$store.commit('setValidQuantity', false)
            this.$emit('validateQuantity')
          }
          else {
            this.eventTracker()
            window.location.href = this.editorUrl
          }
        }
        catch (error) {
          alert(SYSTEM_ERROR.UNKNOWN)
        }
      }
    }
  }
})
